// extracted by mini-css-extract-plugin
export default {"colorInput":"ColorSelector_colorInput__Q+8Ob","colorSelectorContainer":"ColorSelector_colorSelectorContainer__sFwRh","label":"ColorSelector_label__9a-t8"};